import { Grid } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import type { Estado } from '../../stores/estados/estado';
import type { ActualizarEstado, RegistrarEstado } from '../../stores/estados/estados.store';
import { useUIStore } from '../../stores/ui/ui.store';
import type { CommonEntityFormProps } from '../../utils/common-entity-form-props';
import { getLengthOrErrorText } from '../../utils/get-length-or-error-text';
import AppTextField from '../ui/AppTextField';
import EditForm from '../ui/EditForm';

const validationSchema = yup.object({
  id: yup.number(),
  nombre: yup.string().required('El nombre es requerido')
});

type EstadoFormProps = {
  estado?: Estado;
  onSave:
    | ((values: ActualizarEstado) => Promise<void>)
    | ((values: RegistrarEstado) => Promise<boolean>);
} & CommonEntityFormProps;

const EstadoForm = ({ estado, esAgregar, onSave, onDelete, onActivate }: EstadoFormProps) => {
  const esEditar = !esAgregar;
  const activo = esAgregar || estado?.activo === true;
  const inactivo = !activo;
  const status = activo ? 'ACTIVO' : 'INACTIVO';
  const { loading } = useUIStore((state) => state);
  const initialValues = {
    id: estado?.id ?? '',
    nombre: estado?.nombre ?? ''
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      const success = await onSave(values);
      if (success) {
        formik.resetForm();
      }
    },
    enableReinitialize: true
  });

  const reset = () => formik.resetForm({ values: initialValues });

  return (
    <EditForm
      module="estados"
      title="Estados"
      readonly={!activo}
      returnLink="/estados"
      loading={loading}
      showActivate={false}
      showDelete={esEditar}
      onSave={formik.handleSubmit}
      onClear={reset}
      onDelete={onDelete}
      onActivate={onActivate}
    >
      <Grid>
        <Grid container spacing={2}>
          <Grid>
            <AppTextField
              name="id"
              label="Código"
              placeholder="Código"
              value={formik.values.id}
              disabled={true}
            />
          </Grid>
          <Grid size="grow">
            <AppTextField
              name="nombre"
              label="Nombre"
              placeholder="Nombre"
              maxLength={40}
              disabled={loading || inactivo}
              value={formik.values.nombre}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.nombre && Boolean(formik.errors.nombre)}
              helperText={getLengthOrErrorText(
                formik.touched.nombre ? formik.errors.nombre : '',
                formik.values.nombre.length,
                40
              )}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid size={{ xs: 2 }}>
        <AppTextField label="Status" value={status} disabled={true} />
      </Grid>
    </EditForm>
  );
};

export default EstadoForm;
